<template>
  <div class="order">
    <div class="select">
      <el-select
        v-model="addressId"
        filterable
        clearable
        :disabled="status"
        placeholder="请选择地址"
        @change="selectChange"
        style="margin-right: 10px"
      >
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <el-select
        v-model="statusvalue"
        filterable
        clearable
        placeholder="请选择预约项目"
        @change="selectStatusChange"
        style="margin-right: 10px"
      >
        <el-option
          v-for="item in statusOptions"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <el-date-picker
        v-model="timedata"
        type="daterange"
        align="right"
        @change="timedataChange"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
      >
      </el-date-picker>
    </div>
    <div class="table" id="main" style="height: 500px; width: 100%"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";

import { mapState } from "vuex";
import { searchAddress, riskAnalyze, updateAppointment } from "@/api/api";
export default {
  computed: {
    ...mapState(["adminStatus", "token"]),
  },
  data() {
    return {
      activeIndex: "/backstage",
      tableData: [],
      options: [],
      value: "",
      total: 0,
      pagesize: 10,
      currentPage: 1,
      statusOptions: [
        { id: "1", name: "乳腺" },
        { id: "2", name: "甲状腺" },
      ],
      statusvalue: "1",
      addressId: "",
      status: true,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      timedata: [],
      chartDom: "",
      myChart: "",
      option: "",
      highCounts: [0, 0, 0, 0],
      lowCounts: [0, 0, 0, 0],
      middleCounts: [0, 0, 0, 0],
      normalCounts: [0, 0, 0, 0],
    };
  },
  mounted() {
    this.userInfo = sessionStorage.getItem("userInfo");
    console.log(JSON.parse(this.userInfo), "userindo");
    if (JSON.parse(this.userInfo).placeId === null) {
      this.status = false;
    }
    searchAddress().then((res) => {
      console.log(res);
      if (res.code == 0) {
        this.options = res.data;
        this.addressId = this.options[0].id;
      }
      this.loadData();
    });
    // 基于准备好的dom，初始化echarts实例
    this.chartDom = document.getElementById("main");
    this.myChart = echarts.init(this.chartDom);
    this.initChart();
  },
  methods: {
    initChart() {
      this.option = {
        title: {
          text: "数据分析",
        },
        tooltip: {},
        xAxis: {
          data: ["其他", "0-20", "20-30", "30-40", "40+"],
        },
        yAxis: {},
        series: [
          {
            name: "高",
            type: "bar",
            color: "#dd6b66",
            data: this.highCounts,
          },
          {
            name: "中",
            type: "bar",
            color: "#759aa0",
            data: this.middleCounts,
          },
          {
            name: "低",
            type: "bar",
            color: "#e69d87",
            data: this.lowCounts,
          },
          {
            name: "正常",
            type: "bar",
            data: this.normalCounts,
          },
        ],
      };
      this.option && this.myChart.setOption(this.option);
    },

    timedataChange(value) {
      this.loadData();
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClick(row) {
      console.log(row);
    },
    handleClickOver(row, status) {
      let data = {
        status: status,
        id: row.id,
      };
      console.log(data);
      updateAppointment(data).then((res) => {
        if (res.code == 0) {
          console.log(res);
          if (status == 1) {
            this.$message({
              type: "success",
              message: "预约已完成!",
            });
          } else if (status == 2) {
            this.$message({
              type: "warning",
              message: "预约已成功取消!",
            });
          }
          this.loadData();
        }
      });
    },
    handleCurrentChange(value) {
      this.currentPage = value;
      this.loadData();
    },
    selectChange(value) {
      console.log(value);
      this.addressId = value;
      this.loadData();
    },
    selectStatusChange(value) {
      this.statusvalue = value;
      this.loadData();
    },
    loadData() {
      if (!this.addressId) {
        this.$message({
          type: "warning",
          message: "请选择地址!",
        });
      }
      let data = {
        placeId: this.addressId,
        projectId: this.statusvalue,
        startTime: this.formatDateTime(this.timedata[0]),
        endTime: this.formatDateTime(this.timedata[1]),
      };
      if (this.statusvalue !== null && this.statusvalue !== "") {
        data.status = this.statusvalue;
      }
      if (this.addressId) {
        data.id = this.addressId;
      }
      console.log(data);
      riskAnalyze(data).then((res) => {
        if (res.code == 0) {
          console.log(res);
          res.data.forEach((item) => {
            if (item.ageRange == 0) {
              this.highCounts[0] = item.highCount;
              this.lowCounts[0] = item.lowCount;
              this.middleCounts[0] = item.middleCount;
              this.normalCounts[0] = item.normalCount;
            }
            if (item.ageRange == 1) {
              this.highCounts[1] = item.highCount;
              this.lowCounts[1] = item.lowCount;
              this.middleCounts[1] = item.middleCount;
              this.normalCounts[1] = item.normalCount;
            }
            if (item.ageRange == 2) {
              this.highCounts[2] = item.highCount;
              this.lowCounts[2] = item.lowCount;
              this.middleCounts[2] = item.middleCount;
              this.normalCounts[2] = item.normalCount;
            }
            if (item.ageRange == 3) {
              this.highCounts[3] = item.highCount;
              this.lowCounts[3] = item.lowCount;
              this.middleCounts[3] = item.middleCount;
              this.normalCounts[3] = item.normalCount;
            }
          });
          this.initChart();
        } else {
          this.$message({
            type: "warning",
            message: res.message,
          });
        }
      });
    },

    formatDateTime(date) {
      if (!date) {
        return "";
      }
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      var minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      // return y + '-' + m + '-' + d+' '+h+':'+minute;
      return y + "-" + m + "-" + d;
    },
  },
};
</script>

<style>
.select {
  margin: 10px 0;
  padding-left: 10px;
}
.table {
  margin-top: 20px;
}
.order {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 10px;
}
</style>
